import React from 'react';
import { MainLayout } from '@components';
import MRIComponents from './MRI';

export default function MRIPage(props) {
  return <MainLayout footer="main" children={<MRIComponents {...props} />} />;
}
